import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    heading:
      "'Manrope', 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
    body: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  },
  colors: {
    brand: {
      50: "#e6fffa",
      100: "#bff3ef",
      200: "#66f6ff",
      500: "#00d1ff",
      700: "#008fb3",
    },
  },
  styles: {
    global: {
      html: {
        scrollBehavior: "smooth",
      },
      body: {
        bg: "gray.50",
        color: "gray.800",
        lineHeight: "base",
      },
      "*::selection": {
        background: "rgba(0, 209, 255, 0.12)",
      },
    },
  },
  components: {
    Input: {
      baseStyle: {
        field: {
          bg: "gray.700",
          color: "white",
        },
      },
      variants: {
        outline: {
          field: {
            borderColor: "cyan.400",
            _focus: {
              boxShadow: "0 0 0 1px rgba(0,255,255,0.08)",
            },
            _invalid: {
              borderColor: "red.400",
              boxShadow: "0 0 0 1px rgba(255,0,0,0.6)",
            },
          },
        },
      },
    },
    Badge: {
      baseStyle: {
        borderRadius: "md",
        fontWeight: 600,
      },
    },
  },
});

export default theme;
